import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import style from '../../../styles/Weather/weather_weekly_conditions'
import Icon from '../Icon'

import moment from 'moment'

const Top = ({ day, isCollapsed = false }) => {
  const {
    dayOfWeek = '',
    validTimeUtc = '',
    calendarDayTemperatureMax = '',
    calendarDayTemperatureMin = '',
    daypart = []
  } = day || {}
  const { precipChance = '', iconCode = '' } = daypart[0] || {}

  const isToday = moment(validTimeUtc).isSame(moment(), 'day')

  return (
    <div className={`top ${isCollapsed ? 'open' : ''}`}>
      <div className='container-date'>
        {dayOfWeek && <span className='heading'>{isToday ? 'Today' : dayOfWeek}</span>}
        {validTimeUtc && <span className='date'>{moment.utc(validTimeUtc).local().format('MMMM D')}</span>}
      </div>
      <div className='container-icon-summary'>
        {iconCode && <Icon style={style} iconCode={iconCode} />}
        <div className='container-summary'>
          <div className='container-temperatures'>
            {calendarDayTemperatureMax && <span className='max-temperature'>{calendarDayTemperatureMax}</span>}
            {calendarDayTemperatureMin && <span className='min-temperature'>{calendarDayTemperatureMin}</span>}
          </div>
          {(precipChance || precipChance === 0) && (
            <div className='container-precipitation'>
              <span className={`rain-drop-${isCollapsed ? 'white' : 'black'}`}></span>
              <span className='precipitation'>{precipChance}</span>
            </div>
          )}
        </div>
        <div className='container-caret'>
          <FontAwesomeIcon icon={isCollapsed ? faChevronUp : faChevronDown} size={'xs'} />
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

export default Top
